
if (isProductPage) {
    var dataJudgeme = document.querySelector(".reviews__content .jdgm-rev-widg");
} else {
    var dataJudgeme = document.querySelector(".reviews__content .jdgm-revs-tab__content");
}

// if (document.querySelector('.jdgm-rev-widg__summary-text').innerHTML == "Aucun avis pour le moment") {
//     document.querySelector('.reviews').style.display = "none";
// } 

console.log("D1: ", dataJudgeme);
if (dataJudgeme != undefined) {
    var notes = getNotes(dataJudgeme);
    console.log(notes);
    document.querySelector(".reviews__content .reviews__app-note").innerHTML = notes.final.replace(',0', '')+"/5 (" + notes.total + " avis)";
    document.querySelector(".reviews__content [data-reviews-total] span").innerHTML = notes.total;
    // document.querySelector(".reviews__content .reviews__app-total-stars").appendChild('.jdgm-rev-widg__summary-stars')
    document.querySelector(".reviews__content .reviews__app-total-stars").innerHTML = document.querySelector(".jdgm-rev-widg__summary-stars").innerHTML;

    getUsersInformations(dataJudgeme);
} else {
    document.querySelector('.reviews').style.display = "none";
}

function getNotes(dataJudgeme) {
    var notesHtml = dataJudgeme.querySelectorAll("[data-frequency]");
    var currentRatesTmp = 0;
    var maxRatesTmp = 0;
    var notes = {
        "total": 0,
        "final": 0
    }
    notesHtml.forEach((note) => {
        var frequency = parseInt(note.dataset.frequency);
        var rating = note.dataset.rating;

        notes.total = notes.total + frequency;
        maxRatesTmp = maxRatesTmp + (frequency * 5);
        currentRatesTmp = currentRatesTmp + ( frequency * rating); 
    })
    notes.final = parseFloat(currentRatesTmp / maxRatesTmp * 5).toFixed(1);
    notes.final = notes.final.replace(".", ",").toString();
    console.log("Notes: ", notes);
    if (notes.total == 0) {
        document.querySelector('.reviews').style.display = "none";
    }
    return notes;
}

function getUsersInformations(dataJudgeme) {
    var authors = dataJudgeme.querySelectorAll(".jdgm-rev__author");
    var dates = dataJudgeme.querySelectorAll("[data-content]");
    var products = dataJudgeme.querySelectorAll(".jdgm-rev__prod-link");
    var titles = dataJudgeme.querySelectorAll(".jdgm-rev__title");
    var ratings = dataJudgeme.querySelectorAll(".jdgm-rev__rating");
    var descriptions = dataJudgeme.querySelectorAll(".jdgm-rev__body");
    // var stars = dataJudgeme.querySelectorAll(".jdgm-rev-widg__summary-stars");

    if (dates.length > 4) {
        for (var i = 0; i < 4; i++) {
            var currentBlock = document.querySelector("[data-reviews-block='"+i+"'");
            var formatedDateArray = dates[i].dataset.content.split(" ");
            var formatedDate = formatedDateArray[0].split("-");
            var dateFr = formatedDate[2] + "/" + formatedDate[1] + "/" + formatedDate[0];
            
            currentBlock.classList.add('real-review');
            currentBlock.querySelector("[data-reviews-username]").innerHTML = authors[i].innerHTML;
            currentBlock.querySelector("[data-reviews-date] span").innerHTML = dateFr;
            // if (isProductPage) {
            //     currentBlock.querySelector("[data-reviews-selected-product]").innerHTML = document.querySelector("[data-product-title]").dataset.productTitle;
            // } else {
            //     currentBlock.querySelector("[data-reviews-selected-product]").innerHTML = products[i].innerHTML;
            // }
            currentBlock.querySelector("[data-reviews-stars]").innerHTML = ratings[i].innerHTML;
            currentBlock.querySelector("[data-reviews-selected-product]").innerHTML = titles[i].innerHTML;
            currentBlock.querySelector("[data-reviews-description]").innerHTML = descriptions[i].innerHTML;
        }
    } else {
        for (var i = 0; i < dates.length; i++) {
            var currentBlock = document.querySelector("[data-reviews-block='"+i+"'");
            var formatedDateArray = dates[i].dataset.content.split(" ");
            var formatedDate = formatedDateArray[0].split("-");
            var dateFr = formatedDate[2] + "/" + formatedDate[1] + "/" + formatedDate[0];
            
            currentBlock.classList.add('real-review');
            currentBlock.querySelector("[data-reviews-username]").innerHTML = authors[i].innerHTML;
            currentBlock.querySelector("[data-reviews-date] span").innerHTML = dateFr;
            // if (isProductPage) {
            //     currentBlock.querySelector("[data-reviews-selected-product]").innerHTML = document.querySelector("[data-product-title]").dataset.productTitle;
            // } else {
            //     currentBlock.querySelector("[data-reviews-selected-product]").innerHTML = products[i].innerHTML;
            // }
            currentBlock.querySelector("[data-reviews-stars]").innerHTML = ratings[i].innerHTML;
            currentBlock.querySelector("[data-reviews-selected-product]").innerHTML = titles[i].innerHTML;
            currentBlock.querySelector("[data-reviews-description]").innerHTML = descriptions[i].innerHTML;
        }
    }
}